import { render, staticRenderFns } from "./visitDetail.vue?vue&type=template&id=581943a4&scoped=true"
import script from "./visitDetail.vue?vue&type=script&lang=js"
export * from "./visitDetail.vue?vue&type=script&lang=js"
import style0 from "./visitDetail.vue?vue&type=style&index=0&id=581943a4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581943a4",
  null
  
)

export default component.exports